import { render } from "./FloatingBackground.vue?vue&type=template&id=76f68fb4&scoped=true"
const script = {}

import "./FloatingBackground.vue?vue&type=style&index=0&id=76f68fb4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\chris\\Documents\\quizmegpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f68fb4"]])

export default __exports__